import { CSSObject } from "@emotion/react";

import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const lessonPlanWrapperCss: CSSObject = {
  padding: "0 1rem 1rem",
};

export const lessonPlanFooterCss: CSSObject = {
  borderTop: `1px solid ${ui.neutral[100]}`,
  padding: "1rem 0",
};

export const collapseCss = {
  Button: {
    root: {
      width: "100%",
      display: "block",
    },
  },
};

export const collapseContentWrapperCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  alignContent: "center",
};

export const editModeButtonsWrapperCss: CSSObject = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "0.5rem",
  margin: "1rem 0",
  paddingTop: "1rem",
  borderTop: `1px solid ${ui.neutral[100]}`,
};
